import { PAGE_SIZES } from '@crm/shared'
import { z } from 'zod'

/**
 * The client list's URL state (PLAN §4.2: "all reflected in URL search params
 * — shareable, back-button safe"). TanStack Router validates and types this, so
 * a filtered view is just a link someone can paste into chat.
 *
 * Cursors deliberately live here too: the back button should return you to the
 * page you were on, not to page one.
 */
export const clientSearchSchema = z.object({
  search: z.string().optional(),
  status: z.array(z.string()).optional(),
  country: z.array(z.string()).optional(),
  category: z.array(z.string()).optional(),
  district: z.array(z.string()).optional(),
  gender: z.array(z.string()).optional(),
  passportStatus: z.array(z.string()).optional(),
  source: z.array(z.string()).optional(),
  assignedUserId: z.string().optional(),
  ageMin: z.number().int().optional(),
  ageMax: z.number().int().optional(),
  limit: z
    .number()
    .refine((v) => (PAGE_SIZES as readonly number[]).includes(v))
    .optional(),
  cursor: z.string().optional(),
})

export type ClientSearch = z.infer<typeof clientSearchSchema>

/** Search state minus paging — what a count or bulk action is keyed on. */
export function filterOnly(search: ClientSearch): Record<string, unknown> {
  const { cursor: _cursor, limit: _limit, ...filter } = search
  return filter
}
